<div class="auth-wrapper auth-v1 px-2">
  <div class="auth-inner py-2">
    <!-- Reset Password v1 -->
    <div class="card mb-0">
      <div class="card-body">
        <a
          class="brand-logo"
          href="/">
          <img
            [src]="logoService.logoPath"
            alt="brand-logo"
            height="50" />
        </a>

        <h4
          [translate]="'AUTH.PASSWORD.RESET_HEADER'"
          class="card-title mb-1"></h4>
        <form
          (ngSubmit)="onSubmit()"
          [formGroup]="resetPasswordForm"
          class="auth-reset-password-form mt-2">
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <label
                [translate]="'AUTH.PASSWORD.NEW'"
                for="reset-password-new"></label>
            </div>
            <div
              [ngClass]="{
                'is-invalid error': submitted && f['newPassword'].errors,
              }"
              class="input-group input-group-merge form-password-toggle">
              <div class="input-group-prepend">
                <span class="input-group-text"><span [data-feather]="'lock'"></span></span>
              </div>
              <input
                [ngClass]="{
                  'is-invalid error': submitted && f['newPassword'].errors,
                }"
                [type]="passwordTextType ? 'text' : 'password'"
                aria-describedby="reset-password-new"
                autofocus
                class="form-control form-control-merge"
                formControlName="newPassword"
                id="reset-password-new"
                placeholder="············"
                tabindex="1" />
              <span class="input-group-text cursor-pointer"
                ><i
                  (click)="togglePasswordTextType()"
                  [ngClass]="{
                    'icon-eye-off': passwordTextType,
                    'icon-eye': !passwordTextType,
                  }"
                  class="feather font-small-4"></i
              ></span>
            </div>
            @if (submitted && f["newPassword"].errors) {
              <div
                class="invalid-feedback"
                [ngClass]="{ 'd-block': submitted && f['newPassword'].errors }">
                @if (f["newPassword"].errors["required"]) {
                  <div [translate]="'AUTH.ERRORS.PASSWORD'"></div>
                }
                @if (f["newPassword"].errors["minlength"]) {
                  <div [translate]="'AUTH.ERRORS.PASSWORD_MIN_LENGTH'"></div>
                }
              </div>
            }
          </div>
          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <label
                [translate]="'AUTH.PASSWORD.CONFIRM'"
                for="reset-password-confirm"></label>
            </div>
            <div
              [ngClass]="{
                'is-invalid error': submitted && f['confirmPassword'].errors,
              }"
              class="input-group input-group-merge form-password-toggle">
              <div class="input-group-prepend">
                <span class="input-group-text"><span [data-feather]="'lock'"></span></span>
              </div>
              <input
                [ngClass]="{
                  'is-invalid error': submitted && f['confirmPassword'].errors,
                }"
                [type]="confPasswordTextType ? 'text' : 'password'"
                aria-describedby="reset-password-confirm"
                class="form-control form-control-merge"
                formControlName="confirmPassword"
                id="reset-password-confirm"
                placeholder="············"
                tabindex="2" />
              <span class="input-group-text cursor-pointer"
                ><i
                  (click)="toggleConfPasswordTextType()"
                  [ngClass]="{
                    'icon-eye-off': confPasswordTextType,
                    'icon-eye': !confPasswordTextType,
                  }"
                  class="feather font-small-4"></i
              ></span>
            </div>
            @if (submitted && f["confirmPassword"].errors) {
              <div
                class="invalid-feedback"
                [ngClass]="{ 'd-block': submitted && f['confirmPassword'].errors }">
                @if (f["confirmPassword"].errors["required"]) {
                  <div [translate]="'AUTH.ERRORS.PASSWORD'"></div>
                }
                @if (f["confirmPassword"].errors["pwCheck"]) {
                  <div [translate]="'AUTH.ERRORS.PASSWORD_CHECK'"></div>
                }
              </div>
            }
          </div>
          <button
            [translate]="'AUTH.PASSWORD.CONFIRM'"
            class="btn btn-primary d-block w-100"
            rippleEffect
            tabindex="3"></button>
        </form>

        <p class="text-center mt-2">
          <a routerLink="/login">
            <i
              class="mb-25"
              data-feather="chevron-left"></i>
            {{ "AUTH.BACK_TO_LOGIN" | translate }}
          </a>
        </p>
      </div>
    </div>
    <!-- /Reset Password v1 -->
  </div>
</div>
